import { Product } from "~/feature/Product";
import { type CartElement } from "~/pages/B2CRequestPage";
import classes from "./B2CRequestCartItem.module.less";
import classNames from "classnames";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import { Card } from "~/Configurators/Linear/components/Card";
import { IconButton } from "@mui/material";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import { C_PRIMARY } from "~/common/components/icon/Colors";
import { useState } from "react";
import { t } from "i18next";

interface B2CRequestCartItemProps {
  item: CartElement;
  className?: string;
}

const B2CRequestCartItem = ({ item, className }: B2CRequestCartItemProps) => {
  const { data, product } = item;
  const [isOpen, setOpen] = useState(true);

  const isTablet = useIsMinTabletSize();

  const desktop = (
    <div className={classNames(classes.header, className)}>
      <div className={classes.product}>
        <Product.PrimaryImageWithLogos />
        <div className={classes.productInfo}>
          <div className="d-flex">
            {product.preferred && <Product.PreferredIndicator className={"icon-margin"} />}
            <Product.Designation className={classes.designation} />
          </div>
          <Product.MMDChip />
          <Product.ShortDescription clickable={false} />
        </div>
      </div>
      <div className={classes.quantity}>{data.quantity}</div>
      <div className={classes.comment}>{data.comment}</div>
    </div>
  );

  const mobile = (
    <Card disableHover className={classes.mobileHeader}>
      <div className={classes.mobileContainer}>
        <div>
          <div>
            <Product.PrimaryImageWithLogos size="tiny" />
          </div>

          <div className={classNames(classes.productInfo, "mt-16")}>
            <div className="d-flex">
              {product.preferred && <Product.PreferredIndicator className={"icon-margin"} />}
              <Product.Designation className={classes.designation} />
            </div>

            <Product.ShortDescription clickable={false} />
          </div>
        </div>
        <div className="d-flex flex-justify-end">
          <div className={classes.quantity}>
            <p>{t("cartPage.table.header.quantity.title")}</p>
            <span>{data.quantity}</span>
          </div>
        </div>
        {data.comment && (
          <div className={classNames(classes.comment)}>
            <div>
              <p>{t("cartPage.table.comment")}</p>
              {isOpen && <span>{data.comment}</span>}
            </div>
            <div>
              <IconButton color="primary" type="button" size="small" onClick={() => setOpen(!isOpen)}>
                <Icon color={C_PRIMARY} type={isOpen ? IconType.ChevronUp : IconType.ChevronDown} />
              </IconButton>
            </div>
          </div>
        )}
      </div>
    </Card>
  );

  return <Product.Context value={product}>{isTablet ? desktop : mobile}</Product.Context>;
};

export default B2CRequestCartItem;
